import script from "./SpendByCustomerTagPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendByCustomerTagPage.vue?vue&type=script&setup=true&lang=ts"

import "./SpendByCustomerTagPage.vue?vue&type=style&index=0&id=c3f6f64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3f6f64c"]])

export default __exports__